/**
 * Created by odeds on 12/29/15.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseCollection = require("collections/BaseCollection");
    var DateUtility = require("utils/DateUtility");
    var ApiKeyGalleryModel = require("manager-models/data-sources/api-keys/ApiKeyGalleryModel");

    var NAME = "ApiKeysGalleryCollection";

    var ApiKeysGalleryCollection = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {

        ApiKeysGalleryCollection = BaseCollection.extend({
            model: ApiKeyGalleryModel,
            name: NAME,

            /*sort by newest at the top*/
            comparator: function(model) {
                var createdDate = model.get(ApiKeyGalleryModel.KEYS.DATE_CREATED);
                return -new Date(createdDate).getTime(); //returns a long
            },
            getModelByApiKey: function(apiKey){
                var result = _.find(this.models, function(model){
                    return model.get(ApiKeyGalleryModel.KEYS.APIKEY) === apiKey;
                });
                return result;
            }
        });

    }

    LE.module("LEManager", moduleDefinition);

    ApiKeysGalleryCollection.NAME = NAME;

    return ApiKeysGalleryCollection;
});
